document.querySelectorAll( '.b-sticky-boxes' ).forEach( ( block ) => {

	const prefersReducedMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;

	const content = block.querySelector( '.b-sticky-boxes__content' );
	if ( ! content || content.dataset.stickyBoxesReady === 'true' ) {

		return;

	}

	const panelBlocks = Array.from( content.querySelectorAll( '.wp-block-wombat-sticky-box-item' ) );
	if ( ! panelBlocks.length ) {

		return;

	}
	const sidebar = content.querySelector( '.b-sticky-boxes__sidebar' );
	const nav = sidebar?.querySelector( '.b-sticky-boxes__nav' );
	const navList = nav?.querySelector( '.b-sticky-boxes__nav-list' );
	if ( ! sidebar || ! nav || ! navList ) {

		return;

	}
	const headingBlock = content.querySelector( '.wp-block-wombat-heading-with-eyebrow' );

	const header = document.createElement( 'div' );
	header.className = 'b-sticky-boxes__header';

	const layout = document.createElement( 'div' );
	layout.className = 'b-sticky-boxes__layout';

	navList.replaceChildren();

	const panels = document.createElement( 'div' );
	panels.className = 'b-sticky-boxes__panels';

	/**
	 * Set the current active navigation link.
	 *
	 * @param {string} activePanelId Active panel id.
	 */
	const setActiveLink = ( activePanelId ) => {

		navList.querySelectorAll( '[data-sticky-box-link]' ).forEach( ( link ) => {

			const isActive = link.getAttribute( 'href' ) === `#${ activePanelId }`;
			link.classList.toggle( 'is-active', isActive );
			link.setAttribute( 'aria-current', isActive ? 'location' : 'false' );

			if ( isActive && ! prefersReducedMotion ) {

				const navRect = nav.getBoundingClientRect();
				const linkRect = link.getBoundingClientRect();
				const targetScrollLeft = nav.scrollLeft + (
					( linkRect.left - navRect.left ) - ( ( navRect.width - linkRect.width ) / 2 )
				);

				nav.scrollTo( {
					left: Math.max( 0, targetScrollLeft ),
					behavior: 'smooth',
				} );

			}

		} );

	};

	/**
	 * Reveal panel content once it enters the viewport.
	 *
	 * @param {HTMLElement} activePanel Active panel element.
	 */
	const revealPanel = ( activePanel ) => {

		if ( prefersReducedMotion ) {

			return;

		}

		activePanel.classList.add( 'is-in-view' );

	};

	/**
	 * Reset panel reveal state once it leaves the viewport.
	 *
	 * @param {HTMLElement} panel Panel element.
	 */
	const resetPanel = ( panel ) => {

		if ( prefersReducedMotion ) {

			return;

		}

		panel.classList.remove( 'is-in-view' );

	};

	/**
	 * Resolve the active panel from the full visible set.
	 *
	 * Activate the last panel whose top crossed the bottom activation threshold.
	 * Fall back to the first visible panel when none reached the threshold yet.
	 *
	 * @return {?HTMLElement} Active panel element.
	 */
	const getActivePanel = () => {

		const activationLine = window.innerHeight / 2;
		const visiblePanels = panelBlocks.filter( ( panel ) => {

			const panelRect = panel.getBoundingClientRect();
			return panelRect.bottom > 0 && panelRect.top < window.innerHeight;

		} );

		if ( ! visiblePanels.length ) {

			return null;

		}

		const activatedPanels = visiblePanels.filter( ( panel ) => panel.getBoundingClientRect().top <= activationLine );

		if ( activatedPanels.length ) {

			return activatedPanels[ activatedPanels.length - 1 ];

		}

		return visiblePanels[ 0 ];

	};

	if ( headingBlock ) {

		header.appendChild( headingBlock );

	}

	panelBlocks.forEach( ( panel, index ) => {

		const panelId = `sticky-box-panel-${ index + 1 }`;
		const panelIndex = String( index + 1 ).padStart( 2, '0' );
		const tabLabel = panel.querySelector( '.b-sticky-box-item__tab-label' )?.textContent?.trim() || `Panel ${ index + 1 }`;

		panel.id = panelId;
		panels.appendChild( panel );

		const listItem = document.createElement( 'li' );
		listItem.className = 'b-sticky-boxes__nav-item';

		const link = document.createElement( 'a' );
		link.href = `#${ panelId }`;
		link.className = 'b-sticky-boxes__nav-link';
		link.dataset.stickyBoxLink = 'true';
		link.setAttribute( 'aria-current', 'false' );

		const indexNode = document.createElement( 'span' );
		indexNode.className = 'b-sticky-boxes__nav-index';
		indexNode.textContent = panelIndex;

		const titleNode = document.createElement( 'span' );
		titleNode.className = 'b-sticky-boxes__nav-title';
		titleNode.textContent = tabLabel;

		link.appendChild( indexNode );
		link.appendChild( titleNode );
		listItem.appendChild( link );
		navList.appendChild( listItem );

	} );

	nav.appendChild( navList );
	sidebar.prepend( nav );
	layout.appendChild( sidebar );
	layout.appendChild( panels );

	content.appendChild( header );
	content.appendChild( layout );
	content.dataset.stickyBoxesReady = 'true';

	navList.querySelectorAll( '[data-sticky-box-link]' ).forEach( ( link ) => {

		link.addEventListener( 'click', ( event ) => {

			const panelId = link.getAttribute( 'href' )?.replace( '#', '' );
			const panel = panels.querySelector( `#${ panelId }` );
			if ( ! panel ) {

				return;

			}

			event.preventDefault();
			panel.scrollIntoView( {
				behavior: prefersReducedMotion ? 'auto' : 'smooth',
				block: 'start',
			} );
			setActiveLink( panelId );

		} );

	} );

	if ( prefersReducedMotion ) {

		panelBlocks.forEach( ( panel ) => panel.classList.add( 'is-in-view' ) );

		if ( 'IntersectionObserver' in window ) {

			const observer = new IntersectionObserver(
				() => {

					const activePanel = getActivePanel();
					if ( activePanel ) {

						setActiveLink( activePanel.id );

					}

				},
				{
					rootMargin: '-10% 0px -35% 0px',
					threshold: [ 0.05, 0.15, 0.3, 0.5 ],
				}
			);

			panelBlocks.forEach( ( panel ) => observer.observe( panel ) );

		}

	}
	else if ( 'IntersectionObserver' in window ) {

		const observer = new IntersectionObserver(
			( entries ) => {

				entries.forEach( ( entry ) => {

					if ( entry.isIntersecting ) {

						revealPanel( entry.target );
						return;

					}

					resetPanel( entry.target );

				} );

				const activePanel = getActivePanel();
				if ( activePanel ) {

					setActiveLink( activePanel.id );

				}

			},
			{
				rootMargin: '-10% 0px -35% 0px',
				threshold: [ 0.05, 0.15, 0.3, 0.5 ],
			}
		);

		panelBlocks.forEach( ( panel ) => observer.observe( panel ) );

	}
	else {

		panelBlocks.forEach( ( panel ) => revealPanel( panel ) );

	}

	setActiveLink( panelBlocks[ 0 ].id );

} );
